import {
    addToChainAfter,
    markSkipOnCompleteIfOnSuccessIsSet,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ExecuteOnSuccessCallback,
    SendTracking,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { checkoutOption, dispatchCheckoutEvent, dispatchPurchaseEvent } from "@store/Services/AnalyticsService";

addToChainAfter(chain, SendTracking, props => {
    dispatchPurchaseEvent(props.cartToUpdate);
});

replaceInChain(chain, ExecuteOnSuccessCallback, props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess && props.parameter.onSuccess(props.apiResult.cart.id);
    dispatchCheckoutEvent(3, checkoutOption.orderConfirmation, props.cartToUpdate);
});
